import { IconChip } from './PageHeader';
import { useCountUp } from '../kit/hooks';

/** One number in a page's summary row, with the value counting up on change. */
export function StatTile({
  icon,
  label,
  value,
  format,
  detail,
  tone = 'primary',
}: {
  icon: React.ComponentType<{ className?: string }>;
  label: string;
  value: number;
  format?: (n: number) => string;
  detail: string;
  tone?: 'primary' | 'secondary' | 'accent' | 'info' | 'success' | 'warning' | 'error' | 'neutral';
}) {
  const ref = useCountUp<HTMLParagraphElement>(value, format);
  return (
    <div className="card dr-surface">
      <div className="card-body flex-row items-center gap-3 p-4">
        <IconChip icon={icon} tone={tone} size="sm" />
        <div className="min-w-0">
          <p className="text-xs text-base-content/55">{label}</p>
          <p ref={ref} className="text-xl font-semibold tracking-tight tabular-nums">
            {format ? format(value) : value.toLocaleString()}
          </p>
          <p className="truncate text-xs text-base-content/60">{detail}</p>
        </div>
      </div>
    </div>
  );
}
